/**
 * Created by xy on 2018/8/29.
 */
import React,{Component} from "react"
import {NavBar,Steps,Toast,Modal} from 'antd-mobile';
import {refundDetail} from "../../../service/shiftService";
import connect from "react-redux/es/connect/connect";
import moment from 'moment';
import './style.less';
const Step = Steps.Step;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class RentRefund extends Component{
    constructor(props) {
        super(props);
        console.log(props);
        this.state={
            applyTime:"",
            orderNum:"",
            step:0,
            payType:"",
            createTime:"",
            uptime:"",
            refundAmount:'',//实际退款
            preferentialPrice:'',//优惠价格
            payType:'',
            seatPrice:'',//出行位置价格
            serviceCharge:'',//退款手续费
            successTime:'',
        }
    }

    componentDidMount() {
       this.getRefundDetail();
    }
    getRefundDetail(){
        let params = {
            "source": 6,
            "token":this.props.userInfo.token,
            "data":{
                "id": this.props.history.location.shuntType.id,
                "tailoredType":0

            }
          }
        console.log(params)
        Toast.loading("正在加载",0);
        refundDetail(params)
            .then((res) => {
                if (res.data.code === '0000') {
                    Toast.hide();
                    let data = res.data.data
                    this.setState({
                        applyTime:data.applyTime,
                        orderNum:data.orderNum,
                        refundAmount:data.refundAmount,//实际退款
                        payType:data.refundWay,
                        seatPrice:data.seatPrice,//实际支付价格
                        serviceCharge:data.serviceCharge,//手续费
                        successTime:data.successTime,
                        step:data.refundStatus,
                    })
                
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
    render() {
        return (
            <div className="RentRefund">
                <NavBar
                        className="navBar"
                        mode="light"
                        icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                    >
                    退款详情
                </NavBar>
                {/* 头部内容    */}
                <div className="header">退款信息</div> 
                <div className="contentbox">
                    <div className="box">
                        <div className="title">申请时间</div>
                        <div className="content">{this.state.applyTime}</div>
                    </div>
                    <div className="box">
                        <div className="title">原始单号</div>
                        <div className="content">{this.state.orderNum}</div>
                    </div>  
                </div>
                <div className="contentbox">
                    <div className="box">
                        <div className="title">实际支付</div>
                        <div className="content">¥{this.state.seatPrice}</div>
                    </div> 
                    <div className="box">
                        <div className="title">手续费</div>
                        <div className="content"><span className="money">-¥{this.state.serviceCharge}</span></div>
                    </div>  
                       
                </div>
                <div className="contentbox">
                    <div className="box">
                        <div className="title">实际退款</div>
                        <div className="content"><span className="money">¥{this.state.refundAmount}</span></div>
                    </div>  
                    <div className="box">
                        <div className="title">退款方式</div>
                        <div className="content">{this.state.payType == 'wx' ? <div>微信支付</div>:<div>支付宝</div> }</div>
                    </div>
                </div>
                <div className="footer">接收信息</div>
                
                <div className="steps">
                    <Steps current={this.state.step == 1 ? 0 : 2}>
                        <Step 
                        title={(<div className="apply"><div className="commit">申请已提交</div><div className="date">{this.state.applyTime}</div></div>)}  
                        description="您的退款申请已提交，请耐心等待工作人员审核"/>
                        <Step 
                        title="申请审核中"  
                        description="您的退款申请正在由工作人员审核，需要2-3工作日！" />
                        <Step 
                        title={(<div  className="apply">
                        <div className="commit">{this.state.step == 2 && this.state.step != 1 && this.state.step != 4 ? '退款成功':'退款失败'}</div>
                        <div className="date">{this.state.step == 2 && this.state.step != 1 ? this.state.successTime : null}</div></div>)} 
                        description={this.state.step == 2 && this.state.step != 1 && this.state.step != 4 ? '您的退款已由工作人员转入你的微信账户，请查看！':'退款失败，请联系客服'} />
                    </Steps>
                </div>     
            </div>
           
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/RentModule/RentRefund/index.js